<template>
  <div>
    <div class="row">
      <div class="col mx-3">
        <h2 class="h4 pt-3 pb-2">
          Filter by search
        </h2>
        <b-input v-model="search" type="text" class="col-12 col-md-6 ml-0 search-filter" placeholder="Search by lead type" @focus="$emit('click')" />
      </div>
    </div>
    <div class="row pb-3">
      <div v-if="results.length > 0" class="col">
        <ul class="list-unstyled mx-3">
          <li v-for="(wt, wtid) in results"
              :key="wtid"
              class="cursor-pointer lead-type m-2"
              :class="isSelected(wt.id) ? 'font-weight-light': 'font-weight-bold'"
              @click.prevent.stop="toggle(wt, isSelected(wt.id) ? 'remove' : 'add')"
          >
            <b-checkbox :checked="isSelected(wt.id)" class="forced-pointer">
              {{ getDescriptionTranslation(wt) }}
            </b-checkbox>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import notification from "@/imports/mixins/notification";
import workTypeTranslation from "@/imports/mixins/workTypeTranslation";
import company from "@/imports/mixins/company";

export default {
  name: "WorkTypeSearch",
  mixins: [notification, workTypeTranslation, company],
  props: ['value', 'workTypes'],
  data: function() {
    return {
      search: "",
      results: [],
    }
  },
  methods: {
    isSelected: function(workTypeId) {
      return this.value.find(workType => workType.id === workTypeId) !== undefined;
    },
    add: function(workType){
      if (Array.isArray(workType)) {

        this.notify(
          this.$bvToast,
          `Lead type group "${workType[0].category.name}" added`,
          null,
          'success'
        );
        this.$emit('input', [...this.value, ...workType.filter(wt => !this.isSelected(wt.id))]);
      } else {
        this.notify(
          this.$bvToast,
          `Lead type "${workType.description}" added`,
          null,
          'success'
        );
        this.$emit('input', [...this.value, workType]);
      }
    },
    remove: function(workType){
      this.notify(
        this.$bvToast,
        `Lead type "${workType.description}" removed`,
        null,
        'success'
      );
      this.$emit('input', this.value.filter(wt => wt.id !== workType.id));
    },
    toggle: function(workType, action) {
      this.$emit('click')
      if(action === 'add') {
        return this.add(workType);
      }
      return this.remove(workType)
    },
  },
  watch: {
    search: function (value) {
      if (value.length > 2) {
        this.results = [].concat.apply(
          [],
          Object.values(this.workTypes)
            .map(category => category
              .filter(wt => wt.description.search(new RegExp(value, "i")) !== -1)));
      } else if (value === "") {
        this.results = [];
      }
    }
  }
}
</script>

<style scoped lang="scss">
.lead-type {
  font-size: $font-size-14;
}
.search-filter {
  font-size: $font-size-14;
}
.forced-pointer {
  ::v-deep .custom-control-label {
    cursor:pointer !important;
  }
}
</style>
